var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-chips",
    {
      ref: "chips",
      staticClass: "shake-on-error",
      class: { "md-invalid": _vm.error },
      attrs: {
        "md-auto-insert": true,
        "md-format": _vm.formatter,
        "md-placeholder": _vm.placeholder,
        value: _vm.value,
      },
      on: {
        input: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
    },
    [
      _vm.hint
        ? _c("span", { staticClass: "md-helper-text" }, [
            _vm._v(_vm._s(_vm.hint)),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c("span", { staticClass: "md-error" }, [_vm._v(_vm._s(_vm.error))])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }